import { forwardRef, ReactNode } from 'react'
import { cn } from '../utils'

type Props = {
  label: ReactNode
  value: ReactNode
  className?: string
  color?: 'gray' | 'blue' | 'green' | 'yellow' | 'red'
  clickable?: boolean
}

const colorClasses = {
  gray: 'bg-gray-100 border-gray-200 dark:bg-gray-800 dark:border-gray-700',
  blue: 'bg-blue-100 border-blue-200 dark:bg-blue-900 dark:border-blue-800',
  green: 'bg-green-100 border-green-200 dark:bg-green-900 dark:border-green-800',
  yellow: 'bg-yellow-100 border-yellow-200 dark:bg-yellow-900 dark:border-yellow-800',
  red: 'bg-red-100 border-red-200 dark:bg-red-900 dark:border-red-800',
}

export const Tag = forwardRef<HTMLDivElement, Props>(
  ({ label, value, className, color = 'gray', clickable, ...props }, ref) => {
    return (
      <div
        {...props}
        className={cn(
          'inline-flex items-center rounded-md border text-xs font-medium',
          colorClasses[color],
          { 'group cursor-pointer': clickable },
          className
        )}
        ref={ref}
      >
        <div className="flex truncate text-neutral-900">
          <span
            className={cn('flex-none truncate rounded-l-sm bg-neutral-50 p-1 text-xs font-medium', {
              'group-hover:bg-neutral-100': clickable,
            })}
          >
            {label}
          </span>
          <span
            className={cn('truncate rounded-r-sm bg-neutral-100 p-1 text-xs font-normal', {
              'group-hover:bg-neutral-300': clickable,
            })}
          >
            {value}
          </span>
        </div>
      </div>
    )
  }
)

Tag.displayName = 'Tag'
